export const WALLET_AUTOCONNECT_DELAY_MS = 4000;
